const login = {
  title: "Innskráning",
  emailLabel: "Netfang",
  passwordLabel: "Lykilorð",
  forgotPassword: "Gleymt lykilorð?",
  twoFactorLabel: "Tvíþátta kóði",
  twoFactorPlaceholder: "000000",
  twoFactorHint: "Sláðu inn 6 stafa kóðann úr auðkenningarappinu þínu",
  twoFactorLockoutHint:
    "Misstir þú aðgang að auðkenningartækinu? Hafðu beint samband við kerfisstjóra eða yfirmann til að endurstilla tvíþátta auðkenningu.",
  signingIn: "Skrái inn...",
  signIn: "Skrá inn",
  back: "Til baka",
  loginFailed: "Innskráning mistókst",
  footer: {
    newHere: "Nýr notandi?",
    readAbout: "Lestu um kerfið",
    invitationNotice: "— aðgangur er eingöngu veittur með boði.",
  },
};

export default login;
